import React, { useState, useEffect, useContext } from "react";
import './rightDetails.scss';
import { TiStarFullOutline, TiStarHalfOutline, TiStarOutline  } from "react-icons/ti";
import { BsPencil, BsClock } from "react-icons/bs";
import { IoCheckmarkOutline , IoPause, IoClose} from "react-icons/io5";
import { useParams } from 'react-router-dom';
import candidateApi from "../../services/candidateApi";
import { AuthContext } from "../../context/AuthContext";
import { AddAssesment } from "./AddAssesment";
import { RatingDetails } from "./RatingDetails";
import { toast } from "react-toastify";

export const AssessmentAccordion = ({loadDetail}) => {
  const [openIndex, setOpenIndex] = useState(0); 
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  let { id } = useParams(); 
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext);
  const [assessmentDetails, setAssessmentDetails] = useState([]);  
  const [candidateDetails, setCandidateDetails] = useState([]);     
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [accordionData, setAccordionData] = useState([]);
  const [isAssesmentVisible, setIsAssesmentVisible] = useState(false);
  const [selectedAssessmentId, setSelectedAssessmentId] = useState(null);
  const [averageRatings, setAverageRatings] = useState([]);

  const { setReloadDataFunc } = useContext(AuthContext);
 
  const fetchDetails = async () => {
    try {
      if (!id){
        id=candidateIdValue;
      }
      const response = await candidateApi.getJobsByCandidate(id);
      console.log("API Response:", response?.data); 
      if (response?.data?.length > 0) {
        setCandidateDetails(response.data);
        // setSelectedJobId(response.data[0].jobId); 
        const maxJob = response.data.reduce((max, job) =>
          job.jobId > max.jobId ? job : max
        );
        setSelectedJobId(maxJob.jobId); 
      } 
    } catch (error) {
      toast.error("Error fetching candidate job details", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching candidate job details:", error);
    }
  };
  useEffect(() => {
    fetchDetails();
  }, [id]);

  const loadDetails = async () => {   
    try {
      if (!id){
        id=candidateIdValue;
      }
      const jobId = selectedJobId;  
      const response = await candidateApi.fetchAssessmentWithRatings(id, jobId);
      console.log("API Response:", response?.data); 
      const assessments = response?.data?.assessment ? Object.values(response.data.assessment) : [];
      const ratings = response?.data?.ratings ? Object.values(response.data.ratings) : [];
      const avgRatings = response?.data?.averageRatings ? Object.values(response.data.averageRatings) : [];
      setAverageRatings(avgRatings);

      if (assessments.length > 0) {
        console.log("Assessment Data Found", assessments);

        const transformedData = assessments.map((item) => {
          const assessmentRatings = ratings.filter(rating => rating.assessmentId === item.assessmentId);
          return {
            phase: item.phaseValue || "Unknown Phase",
            conductedby: `${item.firstName} ${item.lastName}`.trim() || "N/A",
            actionTaken: item.outcomeValue || "Pending",
            notes: item.remarks || "No notes available",
            assessmentDate: item.assessmentDate ? new Date(item.assessmentDate).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "N/A",
            ratings: assessmentRatings,
            assessmentId: item.assessmentId,
          };
        });

        setAccordionData(transformedData);
      } else {
        console.log("No assessments found.");
      }
    } catch (error) {
      toast.error("Error fetching assessment rating data", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching assessment rating details:", error);
    }
  }; 

  useEffect(() => {
    setReloadDataFunc(() => loadDetails);
    loadDetails();
  }, [id, selectedJobId]);

  const calculateOverallRating = () => {
    if (averageRatings.length === 0) return 0;
    const totalRating = averageRatings.reduce((acc, rating) => acc + parseFloat(rating.averageRating), 0);
    return (totalRating / averageRatings.length).toFixed(2);  // Ensures consistency
  };
  
  const renderStars = (rating) => {
    const numericRating = parseFloat(rating);
    const fullStars = Math.floor(numericRating);
    const decimalPart = numericRating - fullStars;
    const halfStars = decimalPart >= 0.5 ? 1 : 0;
    const emptyStars = 5 - fullStars - halfStars;
  
    return (
      <>
        {[...Array(fullStars)].map((_, idx) => (
          <TiStarFullOutline key={`full-${idx}`} className="starfull" />
        ))}
        {halfStars === 1 && <TiStarHalfOutline className="starhalf" />}
        {[...Array(emptyStars)].map((_, idx) => (
          <TiStarOutline key={`empty-${idx}`} className="starempty" />
        ))}
      </>
    );
  };
const overallRating = calculateOverallRating();  
  useEffect(() => {
    if (loadDetail) {
      loadDetails();
    }
  }, [loadDetail]);

  const handleEditClick=async (item) => { 
    setSelectedAssessmentId(item);
    setIsAssesmentVisible(true);

  };
  const hideAssesmentPopup = () => {
    setIsAssesmentVisible(false)
}
  return (
    <section className="accordion-holder">
      <div className="accordion">
        {accordionData.map((item, index) => (
          <div
            key={index}
            className={`accordion-item ${openIndex === index ? "active" : ""}`}
          >
            <button
              onClick={() => toggleAccordion(index)}
              className="accordion-title d-flex align-items-center"
            >
              <div className="status-span"> 
                <IoCheckmarkOutline />
              </div>
              {item.phase}
              <span className="ms-auto"></span>
            </button>
            {openIndex === index && (
              <div className="accordion-content">
                <div className="d-flex mb-0 top-info">
                  <div className="ms-auto">
                    <span><BsClock />{item.assessmentDate}</span>
                    <button className="btn plain-btn ms-auto" onClick={() => handleEditClick(item.assessmentId)}>
                      <BsPencil />
                    </button>
                  </div>
                </div>
                <div>
                  <div className="d-flex gap-2 mb-2">
                    <label className="form-label d-flex">Conducted by <span className="ms-auto">:</span></label>
                    <p className="mb-0">
                      {item.conductedby}
                    </p>
                  </div>
                  <div className="d-flex gap-2 mb-2">
                    <label className="form-label d-flex">Action Taken <span className="ms-auto">:</span></label>
                    <p className="mb-0">
                      <strong>{item.actionTaken}</strong>
                    </p>
                  </div>
                  <div className="d-flex gap-2 mb-2">
                    <label className="form-label d-flex">Notes <span className="ms-auto">:</span></label>
                    <p className="mb-0">
                      {item.notes}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="rating-info">
                  {item.ratings.map((rating, idx) => (
                    <div key={idx} className="d-flex gap-3 align-items-center mb-2">
                      <div className="label">{rating.criteriaValue}</div>
                      <div className="rating-container d-flex gap-2 align-items-center">
                        <div className="stars d-flex gap-2 align-items-center">
                          {[...Array(5)].map((_, starIdx) => (
                            <TiStarFullOutline key={starIdx} className={starIdx < rating.rating ? "starfull" : ""} />
                          ))}
                        </div>
                        <span className="count">
                          {rating.rating}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
        {isAssesmentVisible && <AddAssesment closePopup={hideAssesmentPopup} editMode={true} assessmentId={selectedAssessmentId}
         jobId={selectedJobId} reloadData={loadDetails}/>}
        
      </div>
    </section>
  );
};